import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-include-secondaries-dialog',
  templateUrl: './include-secondaries-dialog.component.html',
  styleUrls: ['./include-secondaries-dialog.component.css']
})
export class IncludeSecondariesDialogComponent implements OnInit {
  public title = 'Include secondaries?';
  public text = 'Do you want to propagate the new status to secondary cards?';
  public confirm = 'Yes';
  public cancel = 'No';

  public secondaryTokens : string[] = [];


  constructor(
    public dialogRef: MatDialogRef<IncludeSecondariesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    if (this.data != null) {
      this.title = this.data.title || this.title;
      this.text = this.data.text || this.text;
      this.cancel = this.data.cancel || this.cancel;
      this.confirm = this.data.confirm || this.confirm;
      this.secondaryTokens = this.data.secondaryTokens || this.secondaryTokens;
    }
  }


  onYesClick(): void {
    this.dialogRef.close('yes');
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
